import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";
import qs from "querystringify";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/reports";
import validateForm from "../../lib/helpers/validateForm";
import { sumFormat } from "../../lib/helpers/strings";
import { getDateFormat, getMonthFormat } from "../../lib/helpers/dates";
import { getQueryParams } from "../../lib/helpers/bilets";

// UI
import { HeaderPage, Table, Input, Button, Row, Col } from "../../ui";
import IconEdit from "../../ui/src/ui/components/icons/edit";

const TITLE_HEADER = "Отчёт за месяц";

class ReportDayPage extends Component {
  state = {
    titleHeader: TITLE_HEADER,
    loading: true,
    reports: {
      list: [],
      meta: {
        count: 0
      }
    },
    visibleDateFilials: [],
    sumAll: {
      sumAdd: 0,
      sumRemove: 0,
      sumClose: 0,
      sumGive: 0,
      sumReturn: 0,
      sumPercent: 0,
      sumFine: 0,
      sumPercentPlusFine: 0
    },
    search: false,
    form: {
      month: {
        value: "",
        isMonth: "",
        isError: false,
        errors: [],
        validate: Model.month
      }
    },
    buttons: {
      filtersDisabled: false
    }
  };

  renderHistoryList = reports => {
    let reportsData = {
      list: [],
      meta: {}
    };

    if (reports && reports.data && reports.data.length && reports.meta) {
      reportsData.list = reports.data;
      reportsData.meta = { ...reports.meta };
    }

    return { reports: reportsData };
  };

  async componentDidMount() {
    const queryParams = getQueryParams(qs.parse(window.location.search));
    const month = queryParams.month || getMonthFormat(new Date());

    if (!queryParams.month) {
      this.props.history.push({
        pathname: "/reports/month",
        search: `?month=${month}`
      });
    }

    const reports = await API.reports.getOneMonth({ month }, { full: true });

    let titleHeader = `${month} - ${TITLE_HEADER}`;

    this.setState(prevState => {
      return {
        ...this.renderHistoryList(reports),
        titleHeader,
        loading: false,
        form: {
          ...prevState.form,
          month: {
            ...prevState.form.month,
            value: month
          }
        }
      };
    });
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      } else if (form[name].isMonth) {
        value = getMonthFormat(value);
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleMonthpicker = (name, value) => {
    const selectedMonthYear = this.state.form.month.value;

    if (value !== selectedMonthYear) {
      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleSearchSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      const queryParams = getQueryParams(qs.parse(window.location.search));
      const month = queryParams.month || getMonthFormat(new Date());
      const monthSelected = this.state.form.month.value;

      if (month !== monthSelected) {
        this.setState({
          loading: true,
          reports: {
            list: [],
            meta: { saved: false }
          },
          visibleDateFilials: [],
          sumAll: {
            sumAdd: 0,
            sumRemove: 0,
            sumClose: 0,
            sumGive: 0,
            sumReturn: 0,
            sumPercent: 0,
            sumFine: 0,
            sumPercentPlusFine: 0
          },
          footers: {
            month: []
          },
          buttons: {
            filtersDisabled: true
          }
        });

        this.props.history.push({
          pathname: "/reports/month",
          search: `?month=${monthSelected}`
        });

        const reports = await API.reports.getOneMonth(
          { month: monthSelected },
          { full: true }
        );

        let titleHeader = `${monthSelected} - ${TITLE_HEADER}`;

        this.setState({
          ...this.renderHistoryList(reports),
          titleHeader,
          loading: false,
          search: true,
          buttons: {
            filtersDisabled: false
          }
        });
      }
    }
  };

  handleSearchCancel = async e => {
    e.preventDefault();

    this.setState({
      loading: true,
      buttons: {
        filtersDisabled: true
      }
    });

    const month = getMonthFormat(new Date());

    this.props.history.push({
      pathname: "/reports/month",
      search: `?month=${month}`
    });

    const reports = await API.reports.getOneMonth({ month }, { full: true });

    let titleHeader = `${month} - ${TITLE_HEADER}`;

    this.setState(prevState => {
      return {
        ...this.renderHistoryList(reports),
        titleHeader,
        loading: false,
        search: false,
        form: {
          ...prevState.form,
          month: {
            ...prevState.form.date,
            value: month,
            isEdited: true,
            isError: false,
            errors: []
          }
        },
        buttons: {
          filtersDisabled: false
        }
      };
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "Дата",
        render: ({ item }) => {
          return (
            <Link to={`/reports/day?date=${getDateFormat(item.date)}`}>
              {getDateFormat(item.date)}
            </Link>
          );
        },
        footer: { title: "Итого", colSpan: 2 }
      },
      {
        prefix: "касса на",
        title: "Начало дня",
        text: "right",
        render: ({ item }) => sumFormat(item.cash_desk_start_day_all)
      },

      {
        title: "Сумма",
        suffix: "Приходов",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_add_all),
        footer: {
          sum: ({ item }) => item.sum_add_all,
          render: ({ result }) => sumFormat(result)
        }
      },
      {
        title: "Сумма",
        suffix: "Расходов",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_remove_all),
        footer: {
          sum: ({ item }) => item.sum_remove_all,
          render: ({ result }) => sumFormat(result)
        }
      },
      {
        title: "Сумма",
        suffix: "Списаний",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_remove_to_sale_all),
        footer: {
          sum: ({ item }) => item.sum_remove_to_sale_all,
          render: ({ result }) => sumFormat(result)
        }
      },

      {
        title: "Сумма",
        suffix: "Выдач",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_give_all),
        footer: {
          sum: ({ item }) => item.sum_give_all,
          render: ({ result }) => sumFormat(result)
        }
      },
      {
        title: "Сумма",
        suffix: "Возвратов",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_return_all),
        footer: {
          sum: ({ item }) => item.sum_return_all,
          render: ({ result }) => sumFormat(result)
        }
      },

      {
        prefix: "полученные",
        title: "Проценты",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_percent_all),
        footer: {
          sum: ({ item }) => item.sum_percent_all,
          render: ({ result }) => sumFormat(result)
        }
      },
      {
        prefix: "полученные",
        title: "Штрафы",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_fine_all),
        footer: {
          sum: ({ item }) => item.sum_fine_all,
          render: ({ result }) => sumFormat(result)
        }
      },
      {
        prefix: "получено",
        title: "Итого",
        className: "success",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_income_all),
        footer: {
          sum: ({ item }) => item.sum_income_all,
          render: ({ result }) => sumFormat(result)
        }
      },

      {
        prefix: "касса на",
        title: "Конец дня",
        text: "right",
        render: ({ item }) => sumFormat(item.cash_desk_all),
        footer: {
          title: "",
          colSpan: 3
        }
      },
      {
        prefix: "База",
        title: "Материальная",
        suffix: "на конец дня",
        text: "right",
        render: ({ item }) => sumFormat(item.sum_cash_base_give_all)
      },

      {
        title: "",
        className: "icon",
        render: ({ item }) => {
          return (
            <Link to={`/reports/day/${item._id}/edit`}>
              <IconEdit />
            </Link>
          );
        }
      }
    ];
  };

  render() {
    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          title={TITLE_HEADER}
          count={this.state.reports.meta.count}
        />

        <form className="form" onSubmit={this.handleSearchSubmit}>
          <Row>
            <Col padding="no-top-bottom">
              <Input
                placeholder="Выберите месяц отчёта"
                name="month"
                type="month"
                // dateRight={true}
                value={this.state.form.month.value}
                errors={this.state.form.month.errors}
                handleChangeMonth={this.handleMonthpicker}
              />
            </Col>
            <Col padding="no-top-bottom-left">
              <Button
                type="submit"
                theme="dark"
                outline={true}
                size="s"
                disabled={this.state.buttons.filtersDisabled}
              >
                Фильтр
              </Button>
              {this.state.search ? (
                <Button
                  type="button"
                  theme="grey"
                  outline={true}
                  onClick={this.handleSearchCancel}
                  size="s"
                  disabled={this.state.buttons.filtersDisabled}
                >
                  Сбросить
                </Button>
              ) : null}
            </Col>
          </Row>
        </form>

        <Table
          columns={this.getTableColumns()}
          data={this.state.reports.list}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(ReportDayPage));
